import React, { useEffect, useState } from "react";
import allApi from "../../../api/allApi";
import "bootstrap/dist/css/bootstrap.min.css";
import PopupTagDevice from "../common/popupTagDevice";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Loader from "../common/Loader";

const DeviceDetail = () => {
  const location = useLocation();
  const [genieInfo, setDeviceInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const { deviceId } = location.state || {};
  const initialDeviceData = location.state?.deviceInfo || {};
  // const [alarms, setAlarms] = useState([]);
  const [error, setError] = useState(null);
  // const [deviceId, setDeviceId] = useState(initialDeviceData.deviceId || null);
  const [protocolType, setProtocolType] = useState(
    initialDeviceData.protocolType || null
  );
  const deviceData = location.state?.deviceInfo || {};
  const [lanhost, setLanHost] = useState();
  const [tasks, setTasks] = useState([]);
  const [faults, setFaults] = useState([]);

  useEffect(() => {
    if (location.state?.protocolType) {
    }
  }, [location?.state?.protocolType]);

  useEffect(() => {
    listOfLanHost(deviceId);
  }, [deviceId]);

  useEffect(() => {
    fetchTasks();
    fetchFaults();
  }, []);

  const listOfLanHost = async (deviceId) => {
    try {
      const api = new allApi();
      const response = await api.getRequest(`api/tr069/lanHost/${deviceId}`);
      if (response) {
        setLanHost(response);
      }
    } catch (error) {}
  };

  const fetchTasks = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest("api/tr069/alltask");
      if (response) {
        setTasks(response);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  const fetchFaults = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest("api/tr069/allfaults");
      if (response) {
        setFaults(response);
      }
    } catch (error) {
      console.error("Error fetching faults:", error);
    }
  };

  function formatLastSeen(lastSeenTimestamp) {
    if (!lastSeenTimestamp) return "N/A";
    const date = new Date(lastSeenTimestamp); // Directly parse ISO string
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  return (
    <div>
      <div className="device-info-wrap mb-4">
        <div className="inc-card info-card-4">
          <div className="inc-card-title">
            <h3>
              <strong>{deviceData.genieInfo.deviceID.oui || "N/A"}</strong>
            </h3>
          </div>

          <div className="inc-card-body">
            <div className="device-info">
              <div>
                <strong>Device ID:</strong>
                <span>{deviceData.genieInfo.id || "N/A"}</span>
              </div>
              <div>
                <strong>Product Class:</strong>
                <span>
                  {deviceData.genieInfo.deviceID.productClass || "N/A"}
                </span>
              </div>
              <div>
                <strong>Serial Number:</strong>
                <span>
                  {deviceData.genieInfo.deviceID.serialNumber || "N/A"}
                </span>
              </div>
              <div>
                <strong>Software Version:</strong>
                <span>
                  {deviceData.genieInfo.internetGatewayDevice.deviceInfo
                    .softwareVersion.value || "N/A"}
                </span>
              </div>
              <div>
                <strong>Hardware Version:</strong>
                <span>
                  {deviceData.genieInfo.internetGatewayDevice.deviceInfo
                    .hardwareVersion.value || "N/A"}
                </span>
              </div>
              <div>
                <strong>IP Address:</strong>
                <span>
                  {deviceData?.genieInfo?.internetGatewayDevice?.lanDevice
                    ?.lanDeviceConfig?.hosts.host.host_1.ipAddress.value ||
                    "N/A"}
                </span>
              </div>
              <div>
                <strong>Last Inform:</strong>
                <span>{deviceData?.genieInfo.lastInform || "N/A"}</span>
              </div>
              <div>
                <strong>Health:</strong>
                <span
                  style={{
                    color:
                      deviceData.health === "Online"
                        ? "green"
                        : deviceData.health === "Awaiting"
                        ? "orange"
                        : "red",
                  }}
                >
                  {deviceData.health === "Online"
                    ? "Online"
                    : deviceData.health === "Awaiting"
                    ? "Awaiting"
                    : "Offline"}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="inc-card info-card-8">
          <div className="inc-card-title">
            <h3>Lan Host</h3>
          </div>
          <div className="inc-card-body">
            <div className="accordion tr069-accordion" id="accordionWidgets">
              {lanhost?.data?.map((host, index) => (
                <div className="accordion-item" key={index}>
                  <h2 className="accordion-header" id={`heading${index}`}>
                    <button
                      className={`accordion-button ${
                        index !== 0 ? "collapsed" : ""
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${index}`}
                      aria-expanded={index === 0 ? "true" : "false"}
                      aria-controls={`collapse${index}`}
                    >
                      {host.hostName || "Unknown Host"}
                    </button>
                  </h2>
                  <div
                    id={`collapse${index}`}
                    className={`accordion-collapse collapse ${
                      index === 0 ? "show" : ""
                    }`}
                    aria-labelledby={`heading${index}`}
                    data-bs-parent="#accordionWidgets"
                  >
                    <div className="accordion-body">
                      <p>
                        <strong>MAC Address:</strong> {host.macAddress}
                      </p>
                      <p>
                        <strong>IP Address:</strong> {host.ipAddress}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-lg-6">
          <div className="inc-card">
            <div>
              <div className="inc-card-title">
                <h3>Available Tasks</h3>{" "}
                <div className="inc-card-button">
                  <button className="icon-btn">
                    <i className="bin icon"></i>
                  </button>
                  <button className="icon-btn">
                    <i className="refresh icon"></i>
                  </button>
                  <button className="icon-btn">
                    <i className="download icon"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="inc-card-body">
              <div className="inc-card-table">
                <table className="full-table m-head">
                  <thead>
                    <tr>
                      <th>Task Name</th>
                      <th>Device</th>
                      <th>Timestamp</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tasks.length === 0 ? (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>
                          No Tasks found
                        </td>
                      </tr>
                    ) : (
                      tasks.map((task, index) => (
                        <tr key={index}>
                          <td>{task.name || "--"}</td>
                          <td>{task.device || "--"}</td>
                          <td>{formatLastSeen(task.timestamp)}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="inc-card">
            <div>
              <div className="inc-card-title">
                <h3>Faults</h3>
                <div className="inc-card-button">
                  <button className="icon-btn">
                    <i className="bin icon"></i>
                  </button>
                  <button className="icon-btn">
                    <i className="refresh icon"></i>
                  </button>
                  <button className="icon-btn">
                    <i className="download icon"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="inc-card-body">
              <div className="inc-card-table">
                <table className="full-table m-head">
                  <thead>
                    <tr>
                      <th>Device</th>
                      <th>Message</th>
                      <th>Timestamp</th>
                      <th>Provisions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {faults.length === 0 ? (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>
                          No Faults found
                        </td>
                      </tr>
                    ) : (
                      faults.map((fault, index) => (
                        <tr key={index}>
                          <td>{fault.device || "--"}</td>
                          <td>
                            {fault.message || fault.detail?.faultString || "--"}
                          </td>
                          <td>{formatLastSeen(fault.timestamp)}</td>
                          <td>
                            {(() => {
                              try {
                                const parsed = JSON.parse(fault.provisions);
                                return parsed
                                  .flat()
                                  .map((item, i) => (
                                    <span key={i}>{item.toUpperCase()}</span>
                                  ));
                              } catch {
                                return "N/A";
                              }
                            })()}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-lg-12">
          <div className="inc-card">
            <div className="inc-card-title">
              <h3>All Parameters</h3>
            </div>
            <div className="inc-card-body">
              <div className="dashboard-device-info">
                <div className="dashboard-device-detail">
                  <div className="detail-list">
                    <div>
                      <strong>
                        {deviceData.genieInfo.internetGatewayDevice
                          .managementServer.connectionRequestURL.value || "N/A"}
                      </strong>
                      <span>Connection URL</span>
                    </div>
                    <div>
                      <strong>
                        {deviceData.genieInfo.internetGatewayDevice
                          .managementServer.periodicInformEnable.value || "N/A"}
                      </strong>
                      <span>Periodic Inform Enable</span>
                    </div>
                    <div>
                      <strong>
                        {deviceData.genieInfo.internetGatewayDevice
                          .managementServer.parameterKey.value || "N/A"}
                      </strong>
                      <span>Parameter Key</span>
                    </div>
                    <div>
                      <strong>
                        {deviceData?.genieInfo.internetGatewayDevice?.wanDevice
                          .wanDeviceConfig?.wanConnectionDevice
                          .wanConnectionDeviceConfig.wanIPConnection
                          .wanIpConnectionConfig.externalIPAddress.value ||
                          "N/A"}
                      </strong>
                      <span>WAN IP Address</span>
                    </div>
                    <div>
                      <strong>
                        {deviceData?.genieInfo.internetGatewayDevice?.wanDevice
                          .wanDeviceConfig?.wanConnectionDevice
                          .wanConnectionDeviceConfig.wanIPConnection
                          .wanIpConnectionConfig.macAddress.value
                          .deviceUptime || "N/A"}
                      </strong>
                      <span>WAN MAC Address</span>
                    </div>
                    <div>
                      <strong>
                        {formatLastSeen(deviceData.genieInfo.lastInform)}
                      </strong>
                      <span>Last Seen</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <PopupTagDevice
        showPopUp={showTagPopUp}
        handleClose={handleCloseTagModal}
        getTagValue={getTagValueFromPopUp}
        handleSaveTag={handleSaveTagApiCall}
        headerMessage={headerMessage}
      /> */}
    </div>
  );
};

export default DeviceDetail;
